<div
  role="progressbar"
  class="bg-gray-200 rounded-full"
  [class]="styleClass"
  [ngStyle]="style"
  [attr.aria-valuemin]="0"
  [attr.aria-valuenow]="value"
  [attr.aria-valuemax]="100"
  [attr.data-pc-name]="'progressbar'"
  [attr.data-pc-section]="'root'"
  [ngClass]="{
    'progressbar-determinate': mode === 'determinate',
    'progressbar-indeterminate': mode === 'indeterminate',
  }"
>
  <div
    *ngIf="mode === 'determinate'"
    class="progressbar-value progressbar-value-animate"
    [ngStyle]="{
      width: value + '%',
      display: 'flex',
    }"
    [attr.data-pc-section]="'value'"
  >
    <div class="w-full bg-system-500 h-4 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full">
      <div
        class="justify-center"
        *ngIf="showValue && !contentTemplate"
        [ngStyle]="{
          display: value !== null && value !== 0 ? 'flex' : 'none',
        }"
        [attr.data-pc-section]="'label'"
      >
        {{ value }}{{ unit }}
      </div>
      <ng-container *ngTemplateOutlet="contentTemplate; context: { $implicit: value }"></ng-container>
    </div>
  </div>
  <div
    *ngIf="mode === 'indeterminate'"
    class="h-2 text-xs bg-gray-200 rounded-full dark:bg-gray-700 relative overflow-hidden"
    [attr.data-pc-section]="'container'"
  >
    <div
      class="bg-system-500 m-0 h-2 rounded-full progressbar-animated progressbar-value progressbar-value-animate"
      [ngStyle]="{
        background: color,
      }"
      [attr.data-pc-section]="'value'"
    ></div>
  </div>
</div>
